export default {
  API_BASE_URL: '/api/v1/',
  // API_BASE_URL: 'http://localweb/shmu-services/public/v1/',
  SITE_BASE_URL: '/',
  IMG_ASSETS_PATH: '/produkty/assets/img/',
  MAP_TILE_URL: '/',
  IS_DEVEL: false,
}
